import curl from"./curl";export default{info:{key:"shell",title:"Shell",extname:".sh",default:"curl"},curl:curl};
//# sourceMappingURL=index.js.map